import { Icon } from '@chakra-ui/react';
import { ESTIMATED_WEIGHT_SCALE_ICON_SRC } from '@diamond/sol-buyer/utils';
import ErrorOutline from '@mui/icons-material/ErrorOutline';

import { InfoHighlightPill } from '../common/info-highlight-pill';

export {
  ESTIMATED_WEIGHT_EMPTY_INTERSECTION_COPY,
  ESTIMATED_WEIGHT_SCALE_ICON_SRC,
} from '@diamond/sol-buyer/utils';

export const ESTIMATED_WEIGHT_CHECKOUT_STATUS_COPY = 'Menunggu konfirmasi stok';

export const ESTIMATED_WEIGHT_CHECKOUT_COD_NOTICE_COPY =
  'Pembelian produk khusus & timbangan, disarankan pilih COD untuk menghindari selisih harga.';

/**
 * Figma checkout product-row status (19661:188061 / Berat estimasi).
 * Yellow solid pill — same highlight family as PDP banners.
 */
export function EstimatedWeightCheckoutStatus() {
  return (
    <InfoHighlightPill
      iconSrc={ESTIMATED_WEIGHT_SCALE_ICON_SRC}
      size="sm"
      variant="solid"
      whiteSpace="nowrap"
      data-testid="estimated-weight-checkout-status"
    >
      {ESTIMATED_WEIGHT_CHECKOUT_STATUS_COPY}
    </InfoHighlightPill>
  );
}

/**
 * Figma checkout payment COD notice (Timbangan 21683:277461).
 * Placed directly above the COD payment option.
 */
export function EstimatedWeightCheckoutCodNotice() {
  return (
    <InfoHighlightPill
      icon={<Icon as={ErrorOutline} color="#373F41" />}
      size="banner"
      variant="gradient"
      align="flex-start"
      data-testid="estimated-weight-checkout-cod-notice"
    >
      {ESTIMATED_WEIGHT_CHECKOUT_COD_NOTICE_COPY}
    </InfoHighlightPill>
  );
}
